<template>

    <v-card color="#f5f5f5" v-observe-visibility="visibilityChanged">
        <v-toolbar tabs fixed light color="white">
            <v-btn icon @click.native="closeDialog" light>
                <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title v-if="selectedItem.id === 0">Add Supplier Offer Position</v-toolbar-title>
            <v-toolbar-title v-else>Edit Supplier Offer Position - {{selectedItem.id}}
            </v-toolbar-title>
            <v-spacer></v-spacer>

            <v-tabs slot="extension"
                    v-model="activeTab"
                    color="secondary"
                    dark
                    slider-color="primary"
                    class="fixSides"
                    show-arrows

            >
                <v-tab>SUPPLIER OFFER POSITION</v-tab>
            </v-tabs>

            <v-toolbar-items>
                <v-menu
                        transition="slide-y-transition"
                        :nudge-bottom="20"
                        :nudge-right="0"
                        :nudge-left="0">
                    <v-btn @click="openBottomSheet($vuetify.breakpoint.mdAndDown)" id="menu-button"
                           slot="activator"
                           icon>

                        <v-icon dark>more_vert</v-icon>
                    </v-btn>
                    <v-list v-show="$vuetify.breakpoint.lgAndUp">
                        <v-list-tile @click.native="saveAll()">
                            <v-list-tile-title>
                                <v-icon color="secondary">save</v-icon>
                            </v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile @click.native="deleteAll()">
                            <v-list-tile-title>
                                <v-icon color="red">delete</v-icon>
                            </v-list-tile-title>
                        </v-list-tile>
                    </v-list>
                </v-menu>
            </v-toolbar-items>

        </v-toolbar>

        <v-tabs-items class="fromTop" v-model="activeTab"
                      :touchless="touchless"
        >
            <v-tab-item>

                <v-layout wrap>
                    <v-container grid-list-md>
                        <v-flex xs12 md10 offset-md1 xl6 offset-xl3>
                            <v-hover>
                                <v-card slot-scope="{ hover }"
                                        :class="`elevation-${hover ? 4 : 1}`">
                                    <v-card-title class="headline">Supplier Offer Position
                                        <v-spacer></v-spacer>
                                    </v-card-title>

                                    <v-card-title>

                                        <v-flex xs12 pr-3 pl-3>
                                            <v-subheader>Product</v-subheader>
                                            <v-divider></v-divider>
                                        </v-flex>

                                        <v-flex xs12 md6 pl-4 pa-2>
                                            <FakeItem v-show="getInitialLoading">
                                            </FakeItem>
                                            <v-combobox
                                                    v-show="!getInitialLoading"
                                                    clearable
                                                    :items="getProducts"
                                                    label="Product-Reference"
                                                    v-model="selectedProduct"
                                                    item-text="reference"
                                                    :filter="referenceFilter"
                                            ></v-combobox>
                                        </v-flex>

                                        <v-flex xs12 md6 pl-4 pa-2>
                                            <FakeItem v-show="getInitialLoading">
                                            </FakeItem>

                                            <v-autocomplete
                                                    v-show="!getInitialLoading"
                                                    clearable
                                                    :items="getManufacturers"
                                                    label="Manufacturer"
                                                    v-model="selectedItem.product.manufacturers_id"
                                                    item-value="id"
                                                    item-text="name"
                                                    :disabled="manufacturerPreselected"
                                            ></v-autocomplete>
                                        </v-flex>


                                        <v-flex xs12 md2 pl-4 pa-2>
                                            <FakeItem v-show="getInitialLoading">
                                            </FakeItem>
                                            <v-text-field
                                                    v-show="!getInitialLoading"
                                                    label="Quantity"
                                                    v-model="selectedItem.quantity"
                                                    type="number"
                                                    min="1"
                                            ></v-text-field>
                                        </v-flex>


                                        <v-flex xs12 md4 pl-4 pa-2>
                                            <FakeItem v-show="getInitialLoading">
                                            </FakeItem>
                                            <v-autocomplete
                                                    v-show="!getInitialLoading"
                                                    clearable
                                                    :items="getUnits"
                                                    label="Unit"
                                                    v-model="selectedItem.units_id"
                                                    item-value="id"
                                                    item-text="name"
                                            ></v-autocomplete>
                                        </v-flex>

                                        <v-flex xs12 md3 pl-4 pa-2>
                                            <FakeItem v-show="getInitialLoading">
                                            </FakeItem>

                                            <v-text-field
                                                    v-show="!getInitialLoading"
                                                    id="supplierOfferPositionPrice"
                                                    :suffix="getSupplierOfferCurrency"
                                                    label="Unit-Price"
                                                    v-model.lazy="getSupplierOfferPositionPrice"
                                                    v-money="money"
                                            >
                                            </v-text-field>

                                        </v-flex>

                                        <v-flex xs12 md3 pl-4 pa-2>
                                            <FakeItem v-show="getInitialLoading">
                                            </FakeItem>
                                            <v-text-field
                                                    v-show="!getInitialLoading"
                                                    :suffix="getSupplierOfferCurrency"
                                                    label="Total-Price"
                                                    v-model="totalSupplierOfferPositionPrice"
                                                    readonly
                                            >
                                            </v-text-field>

                                        </v-flex>

                                        <v-flex xs12 md6 pl-4 pa-2>
                                            <FakeItem v-show="getInitialLoading">
                                            </FakeItem>
                                            <v-text-field
                                                    v-show="!getInitialLoading"
                                                    label="HS-Code"
                                                    v-model="selectedItem.product.hscode"
                                                    counter
                                                    maxlength="255"
                                                    :disabled="manufacturerPreselected"
                                            ></v-text-field>
                                        </v-flex>

                                        <v-flex xs12 md6 pl-4 pa-2>
                                            <FakeItem v-show="getInitialLoading">
                                            </FakeItem>
                                            <v-text-field
                                                    v-show="!getInitialLoading"
                                                    suffix="kg"
                                                    label="Net Weight"
                                                    v-model="selectedItem.product.weight"
                                                    type="number"
                                                    step=".01"
                                                    min="0"
                                                    :disabled="manufacturerPreselected"
                                            ></v-text-field>
                                        </v-flex>

                                        <v-flex xs12 md6 pl-4 pa-2>
                                            <FakeItem v-show="getInitialLoading">
                                            </FakeItem>
                                            <v-text-field
                                                    v-show="!getInitialLoading"
                                                    label="Delivery Time"
                                                    v-model="selectedItem.delivery_time.value"
                                                    type="number"
                                                    step=".01"
                                                    min="0"
                                            ></v-text-field>
                                        </v-flex>

                                        <v-flex xs12 md6 pl-4 pa-2>
                                            <FakeItem v-show="getInitialLoading">
                                            </FakeItem>
                                            <v-autocomplete
                                                    v-show="!getInitialLoading"
                                                    clearable
                                                    v-model="selectedItem.delivery_time.delivery_times_types_id"
                                                    :items="getDeliveryTimeTypes"
                                                    label="Type"
                                                    item-value="id"
                                                    item-text="name"
                                            ></v-autocomplete>
                                        </v-flex>

                                        <v-flex xs12 md12 pl-4 pa-2>
                                            <FakeItem v-show="getInitialLoading">
                                            </FakeItem>
                                            <v-textarea
                                                    v-show="!getInitialLoading"
                                                    auto-grow
                                                    rows="4"
                                                    label="Product Description"
                                                    v-model="selectedItem.product.product_description.description"
                                                    counter
                                                    maxlength="500"
                                                    :disabled="manufacturerPreselected"
                                            ></v-textarea>
                                        </v-flex>

                                        <v-flex xs12 md12 pl-4 pa-2>
                                            <FakeItem v-show="getInitialLoading">
                                            </FakeItem>
                                            <v-textarea
                                                    v-show="!getInitialLoading && selectedItem.remark !== null"
                                                    auto-grow
                                                    rows="4"
                                                    label="Remark"
                                                    v-model="selectedItem.remark"
                                                    counter
                                                    maxlength="500"
                                            ></v-textarea>
                                        </v-flex>
                                        
                                        <v-flex xs12 pr-3 pl-3>
                                            <v-layout wrap>
                                                <v-subheader>Discounts</v-subheader>
                                                <v-spacer></v-spacer>
                                                <v-btn icon color="secondary darken-1"
                                                       @click.native="addSupplierOfferPositionDiscount()">
                                                    <v-icon>add</v-icon>
                                                </v-btn>
                                            </v-layout>
                                            <v-divider></v-divider>
                                        </v-flex>

                                        <v-flex xs12 md12 pl-4 pa-2>
                                            <FakeTable v-show="getInitialLoading">
                                            </FakeTable>
                                            <v-layout wrap v-show="!getInitialLoading">
                                                <template
                                                        v-for="(item, index) in selectedItem.discounts">
                                                    <v-card-text>
                                                        <v-layout wrap pb-3>
                                                            <v-flex xs12 md2>

                                                                <v-text-field
                                                                        suffix="%"
                                                                        label="Discount"
                                                                        v-model="item.value"
                                                                        type="number"
                                                                        step=".01"
                                                                        min="0"
                                                                        max="100"
                                                                ></v-text-field>

                                                            </v-flex>

                                                            <v-flex xs12 md6>
                                                                <v-textarea
                                                                        auto-grow
                                                                        rows="1"
                                                                        label="Discount description"
                                                                        v-model="item.description"
                                                                        counter
                                                                        maxlength="255"
                                                                ></v-textarea>
                                                            </v-flex>

                                                            <v-flex xs8 md3>
                                                                <v-autocomplete
                                                                        clearable
                                                                        v-model="item.type"
                                                                        :items="discountTypes"
                                                                        label="Type"
                                                                ></v-autocomplete>

                                                            </v-flex>

                                                            <v-spacer></v-spacer>
                                                            <v-btn :loading="getRemovingSupplierOfferPositionDiscount(index)"
                                                                   icon ripple
                                                                   @click.native="removeSupplierOfferPositionDiscount(index)">
                                                                <v-icon color="red lighten-1">delete</v-icon>
                                                            </v-btn>
                                                        </v-layout>
                                                        <v-divider></v-divider>
                                                    </v-card-text>
                                                </template>
                                            </v-layout>
                                        </v-flex>

                                        <!--                                        <ProcessHistory
                                                                                        :historyTypeID="selectedItem.histories_types_id"
                                                                                        :itemID="selectedItem.id"
                                                                                        :selectedItem="selectedItemForHistory"
                                                                                ></ProcessHistory>-->

                                    </v-card-title>

                                    <v-card-actions>
                                        <v-layout mt-2 pb-3 pr-3>
                                            <v-spacer></v-spacer>
                                            <v-btn :loading="saveProcess" color="secondary"
                                                   @click.native="saveSupplierOfferPosition()">
                                                Save
                                                <v-icon class="white--text" right>save</v-icon>
                                            </v-btn>
                                        </v-layout>
                                    </v-card-actions>
                                </v-card>
                            </v-hover>
                            <v-layout mt-5 row justify-end>
                            </v-layout>
                        </v-flex>

                    </v-container>
                </v-layout>
            </v-tab-item>
        </v-tabs-items>
    </v-card>

</template>

<script>
    import {
        Settings,
        ProductSettings,
        Procurement,
        SupplierOffers,
        SupplierOfferPositions,
        ContactPersonSettings,
        ManufacturersSettings
    } from '../../../store/namespace-helper'
    import supplierOfferPositions from '../../SupplierOffers/SupplierOfferPositions/SupplierOfferPositions.vue'
    import DatetimePicker from '../../Shared/DatetimePicker.vue'
    import UploadDocumentPicker from '../../Shared/UploadDocumentPicker.vue'
    import DocumentTokenChip from '../../Shared/DocumentTokenChip.vue'
    import FakeItem from '../../Shared/FakeItem.vue'
    import FakeTable from '../../Shared/FakeTable.vue'
    import ProcessHistory from '../../Shared/ProcessHistory.vue'

    import {dateFunctionFilters} from '../../../mixins/dateFunctionFilters'
    import {initialLoadingMixin} from '../../../mixins/initialLoadingMixin'
    import {comboAutoCompleteFiltersMixin} from '../../../mixins/comboAutoCompleteFiltersMixin'

    import {VMoney} from 'v-money'

    /*   import _ from 'lodash' */

    export default {
      components: {
        supplierOfferPositions,
        DatetimePicker,
        UploadDocumentPicker,
        DocumentTokenChip,
        FakeItem,
        FakeTable,
        ProcessHistory
      },
      name: 'add-supplier-offer',
      mixins: [dateFunctionFilters, initialLoadingMixin, comboAutoCompleteFiltersMixin],
      data () {
        return {
          activeTab: 0,
          headers: [
                    {text: 'Offer-ID', value: 'id'},
                    {text: 'Offer Number', value: 'offer_number'},
                    {text: 'Account', value: 'accounts_id'},
                    {text: 'Status', value: 'customers_offers_status_id'},
                    {text: 'Valid Until', value: 'valid_until'}
          ],
          countries: this.$store.getters.countries,
          selectedOffers: [],
          selectedOfferIDs: [],
          pagination: {'sortBy': 'id', 'descending': true},
          search: '',
          total: 0,
          rowsPageItems: [5, 10, 25, 50, 100, 250],
          customContactFilter (item, queryText, itemText) {
            const isMatch = (test, query) => {
              return test.toString().toLowerCase().indexOf(query.toString().toLowerCase()) > -1
            }
            const query = queryText || ''
            const displayText = item.title + ' ' + item.firstname + ' ' + item.lastname
            const rc = isMatch(item.firstname, query) ||
                        isMatch(item.lastname, query) ||
                        isMatch(item.email, query) ||
                        isMatch(displayText, query)
            console.log(`filter: ${JSON.stringify(item)}, '${query}', ${JSON.stringify(itemText)} => ${rc}`)
            return rc
          },
          isVisible: false,
          supplierContact: {},
          supplierUpdated: 0,
          onDismissed: false,
          sheet: false,
          searchCustomer: '',
          searchCustomerBranchOffice: '',
          searchCustomerBranchOfficeContact: '',
          valid_until: '',
          statuses: [],
          allAccounts: [],
          touchless: true,
          uploadedDocument: null,
          selectedItemForHistory: null,
          saveProcess: false,
          selectedProduct: '',
          manufacturerPreselected: false,
          money: {
            decimal: ',',
            thousands: '.',
            prefix: '',
            suffix: '',
            precision: 2,
            masked: true /* doesn't work with directive */
          },
          totalSupplierOfferPositionPrice: '0,00',
          getSupplierOfferPositionPrice: '0,00',
          indexToDelete: 0,
          discountTypes: ['percent']
        }
      },
      methods: {
        visibilityChanged (isVisible, entry) {
          if (this.isVisible !== isVisible) {
            this.isVisible = isVisible
            if (isVisible) {
              console.log('tab visible, load data')
                        /*           this.loadSelectedItemForHistory() */
              this.loadProducts()
              this.loadUnits()
              this.loadDeliveryTimeTypes()
              this.loadManufacturers()
              this.initialLoadingTimeout(850)
              this.setMoneyFieldUnitPrice(this.selectedItem.unit_price)
            } else {
              this.supplierUpdated = 0
              this.resetInitialLoadingState()
            }
          }
        },
        closeDialog () {
          this.$store.dispatch(SupplierOfferPositions.actions.setSelectedSupplierOfferPosition, null)
          this.$store.dispatch(SupplierOfferPositions.actions.openCloseDialog)
          this.selectedProduct = null
          this.totalSupplierOfferPositionPrice = '0,00'
          this.setMoneyFieldUnitPrice('0,00')
          this.activeTab = 0
        },
        loadCurrencies () {
          this.$store.dispatch(Settings.actions.loadAllCurrencies)
        },
        loadTermsOfPayments () {
          this.$store.dispatch(Settings.actions.loadTermsOfPayments)
        },
        loadTermsOfDeliveries () {
          this.$store.dispatch(Settings.actions.loadTermsOfDeliveries)
        },
        loadSelectedItemForHistory () {
          this.$store.dispatch(Procurement.actions.loadProcurement, this.selectedItem).then(response => {
            this.selectedItemForHistory = response.data.data
          })
        },
        onDismissedError () {
          this.$store.dispatch(Settings.actions.clearNetworkError)
        },
        openBottomSheet (payload) {
          if (payload) {
            this.$store.dispatch('openCloseBottomSheet')
          }
        },
        loadSupplierContacts (val) {
          this.$store.dispatch(ContactPersonSettings.actions.loadContactPersonsBySupplierId, val)
        },
        loadAllSuppliers: function () {
          this.$store.dispatch(Settings.actions.loadAllSuppliers)
        },
        loadProducts () {
          this.$store.dispatch(ProductSettings.actions.loadAllProducts)
        },
        loadManufacturers () {
          this.$store.dispatch(ManufacturersSettings.actions.loadAllManufacturers)
        },
        loadUnits () {
          this.$store.dispatch(Settings.actions.loadAllUnits)
        },
        calculateTotalSupplierOfferPositionPrice () {
          if (this.selectedItem.unit_price !== 0 && this.selectedItem.quantity !== 0 && typeof this.selectedItem.quantity !== 'undefined') {
            var tempUnitPrice = this.selectedItem.unit_price
            this.selectedItem.discounts.forEach(function (item) {
              if (item.type === 'percent') {
                tempUnitPrice -= (tempUnitPrice * (item.value / 100))
              }
            })
            this.totalSupplierOfferPositionPrice = new Intl.NumberFormat('de-DE', {
              style: 'decimal',
              minimumFractionDigits: 2,
              maximumFractionDigits: 2

            }).format(tempUnitPrice * this.selectedItem.quantity)
          }
        },
        setMoneyFieldUnitPrice (val) {
          var element = document.getElementById('supplierOfferPositionPrice')
          var event = new Event('input')
          if (typeof element !== 'undefined' && element !== null) {
            element.value = ''
            element.dispatchEvent(event)
            element.value = new Intl.NumberFormat('de-DE', {
              style: 'decimal',
              minimumFractionDigits: 2,
              maximumFractionDigits: 2

            }).format(val)
            element.dispatchEvent(event)
          }
        },
        loadDeliveryTimeTypes () {
          this.$store.dispatch(Settings.actions.loadAllDeliveryTimeTypes)
        },
        addSupplierOfferPositionDiscount () {
          this.selectedItem.discounts.push({
            id: 0,
            suppliers_offers_position_id: 0,
            value: 0.00,
            type: 'percent'
          })
        },
        removeSupplierOfferPositionDiscount (index) {
          this.indexToDelete = index
          var id = this.selectedItem.discounts[index].id

          if (id === 0) {
            this.selectedItem.discounts.splice(index, 1)
          } else {
            this.$store.dispatch(SupplierOfferPositions.actions.removeSupplierOfferPositionDiscount, id).then(response => {
              this.selectedItem.discounts.splice(index, 1)
            })
          }
        },
        getRemovingSupplierOfferPositionDiscount (val) {
          if (this.indexToDelete === val) {
            return this.$store.getters[SupplierOfferPositions.getters.getRemovingSupplierOfferPositionDiscount]
          }
        },
        saveSupplierOfferPosition () {
          this.saveProcess = true
          if (this.selectedItem.id === 0) {
            this.selectedItem.suppliers_offers_id = this.selectedSupplierOffer.id
                    /*       this.selectedItem.inquiries_positions_id = this.selectedItem.id */
          }
          if (typeof this.selectedProduct === 'string') {
            this.selectedItem.product.reference = this.selectedProduct
          }
          this.$store.dispatch(SupplierOfferPositions.actions.saveSupplierOfferPosition, this.selectedItem).then(response => {
            this.saveProcess = false
          }).catch(err => {
            this.saveProcess = false
            console.log('err: ' + JSON.stringify(err))
          })
        }
      },
      computed: {
        selectedItem () {
          if (typeof this.$store.getters[SupplierOfferPositions.getters.getSelectedSupplierOfferPosition].product !== 'undefined') {
            if (this.$store.getters[SupplierOfferPositions.getters.getSelectedSupplierOfferPosition].product.id !== 0) {
              this.selectedProduct = this.$store.getters[SupplierOfferPositions.getters.getSelectedSupplierOfferPosition].product
            }
          }
          return this.$store.getters[SupplierOfferPositions.getters.getSelectedSupplierOfferPosition]
        },
        selectedSupplierOffer () {
          return this.$store.getters[SupplierOffers.getters.getSelectedSupplierOffer]
        },
        getSupplierContacts () {
          return this.$store.getters[ContactPersonSettings.getters.getContactPersonsForSupplierId]
        },
        getAllSuppliers () {
          return this.$store.getters[Settings.getters.getAllSuppliers]
        },
        getCurrencies () {
          return this.$store.getters[Settings.getters.getAllCurrencies]
        },
        loading () {
          return this.$store.getters[Settings.getters.loading]
        },
        tabsDisabled () {
          return this.$store.getters[SupplierOfferPositions.getters.getSelectedSupplierOfferPosition].id === 0
        },
        termsOfPayment () {
          return this.$store.getters[Settings.getters.getTermsOfPayments]
        },
        termsOfDelivery () {
          return this.$store.getters[Settings.getters.getTermsOfDeliveries]
        },
        getProducts () {
          return this.$store.getters[ProductSettings.getters.getAllProducts]
        },
        getManufacturers () {
          return this.$store.getters[ManufacturersSettings.getters.getAllManufacturers]
        },
        getUnits () {
          return this.$store.getters[Settings.getters.getAllUnits]
        },
        getSupplierOfferCurrency () {
          return this.selectedItem.suppliers_offer.currency.name
        },
        getDeliveryTimeTypes () {
          return this.$store.getters[Settings.getters.getAllDeliveryTimeTypes]
        }
      },
      watch: {
        selectedProduct: {
          handler (val) {
            console.log('selectedProduct')
            console.log(val)
            if (val === null) {
              return
            }
            if (typeof val === 'undefined') {
              this.selectedItem.product.manufacturers_id = null
              this.selectedItem.product.id = 0
              this.selectedItem.product.hscode = null
              this.selectedItem.product.weight = null
              this.selectedItem.product.product_description = {
                description: ''
              }
              this.selectedItem.products_id = null
              return
            }
    
            if (typeof val !== 'string') {
              this.selectedItem.product.manufacturers_id = val.manufacturers_id
              this.selectedItem.product.id = val.id
              this.selectedItem.product.hscode = val.hscode
              this.selectedItem.product.weight = val.weight
              this.selectedItem.product.product_description = val.product_description
              this.selectedItem.product.reference = val.reference
              this.selectedItem.products_id = val.id
              this.manufacturerPreselected = true
            } else {
              this.selectedItem.product.manufacturers_id = null
              this.selectedItem.products_id = null
              this.manufacturerPreselected = false
            }
          },
          deep: true
        },
        getSupplierOfferPositionPrice: {
          handler (val) {
            var formatRemoved = val.replace(/\./g, '')
            formatRemoved = formatRemoved.replace(/,/g, '.')
            this.selectedItem.unit_price = formatRemoved

            this.calculateTotalSupplierOfferPositionPrice()
          }
        },
        selectedItem: {
          handler (val) {
            this.calculateTotalSupplierOfferPositionPrice()
          },
          deep: true
        }

      },
      directives: {money: VMoney}
    }
</script>


<style scoped>

    #menu-button {
        margin-top: 4px;
        width: 55px;
        height: 55px;
    }

    .fromTop {
        padding-top: 120px;
    }

    .fixSides::before {
        position: absolute;
        content: "";
        background-color: var(--secondary-color);
        height: 100%;
        width: 110vw;
        top: 0px;
        left: -24px;
    }

    .statusSelecter {
        width: 80px;
    }

    .process-history {
        text-align: right;
        width: 100%;
        font-size: 0.95rem;
    }

</style>


// WEBPACK FOOTER //
// src/components/SupplierOffers/SupplierOfferPositions/AddSupplierOfferPosition.vue